import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import React from "react";
import type { RootState } from "../store";
import { useOneSignal } from "../hooks/useOneSignal";

const ProtectedRoute = () => {

    const navigate = useNavigate();
    const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);

    const is_profile_completed = localStorage.getItem("is_profile_completed");

    useOneSignal()

    React.useEffect(() => {
        if (isAuthenticated && is_profile_completed === "false") {
            navigate("/onboarding", {
                state: { directToOnboarding: true },
                replace: true,
            });
        }
    }, [isAuthenticated, is_profile_completed, navigate]);

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
